<script context="module" lang="ts"></script>

<script lang="ts">
    import { file } from "$lib/state";
    import { onMount } from "svelte";
    import { COMMANDS } from "$lib/commands";

    let history = { past: [] as string[], future: [] as string[] };
    onMount(() => {
        let sub: any;
        let fileSubscription = file.subscribe(file => {
            sub?.unsubscribe();
            if (!file) return;

            history = file.getHistory();
            sub = file.onHistoryChanged.subscribe(() => {
                history = file.getHistory();
            });
        });
        return () => {
            sub?.unsubscribe();
            fileSubscription();
        };
    });


    function format(item: string) {
        let res = /(.*): '(.*)' (\((.*)\))?/g.exec(item);
        const [, type, name, , info] = res ?? [];
        return [type, name, info];
    }

    function repeatUndo(steps: number) {
        return () => {
            COMMANDS.commands["general.undo"].invoke(steps);
        }
    }

    function repeatRedo(steps: number) {
        return () => {
            COMMANDS.commands["general.redo"].invoke(steps);
        }
    }

    function undoAll() {
        COMMANDS.commands["general.undo"].invoke(history.past.length);
    }
</script>

<!----------------------------------------------------------------------------->

<div class="history">
    {#each history.future as future, index}
        {@const [type, name, info] = format(future)}
        <div class="item" on:click={repeatRedo(history.future.length - index)}>
            <span>{type}:</span>
            <span>{name}</span>
            <span>({info})</span>
        </div>
    {/each}
    <hr />
    {#each history.past as past, index}
        {@const [type, name, info] = format(past)}
        <div class="item" on:click={repeatUndo(index)}>
            <span>{type}:</span>
            <span>{name}</span>
            <span>({info})</span>
        </div>
    {/each}
    <span class="end" on:click={undoAll}>end of history</span>
</div>

<!----------------------------------------------------------------------------->

<style>
    .history {
        display: grid;
        grid-template-columns: 8ch max-content 1fr;
        column-gap: 1ch;
        white-space: nowrap;
    }

    .item {
        display: grid;
        grid-column: 1/-1;
        grid-template-columns: subgrid;
    }

    hr {
        all: unset;
        position: relative;
        grid-column: 1 / -1;
        background: var(--gacc200);
        height: 2px;
        margin-bottom: -2px;
        margin-left: 0.25em;

        &::before {
            content: "Current";
            position: absolute;
            right: 1ch;
            top: 0;
            font-size: 0.75rem;
            color: var(--tacc);
        }
    }

    span:nth-of-type(3n + 1) {
        text-align: right;
        padding-left: 1ch;
    }

    span:nth-of-type(3n + 3) {
        color: var(--t400);
    }

    span.end {
        all: unset;
        grid-column: 1 / -1;
        color: var(--t400);
        padding-left: 1ch;
    }
</style>
